import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  saveLoading: false,
  jobPositionsLength: 0,
  jobPositions: [],
  jobPositionsError: "",
  formError: "",
};

export default function jobPositionsReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_JOB_POSITIONS:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_JOB_POSITIONS:
      return { ...state, saveLoading: action.payload };
    case actions.GET_JOB_POSITIONS:
      return {
        ...state,
        jobPositions: action.payload.jobPositions,
        jobPositionsLength: action.payload.jobPositionsLength,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.JOB_POSITIONS_FAIL:
      return { ...state, factorNameError: action.payload };
    default:
      return state;
  }
}
